module.exports = __webpack_public_path__ + "static/media/large-screen02.5c773a9d.png";